<template>
  <template v-for="(item, index) in menus" :key="index">
    <template v-if="item.children && item.children.length > 0">
      <el-sub-menu :index="index">
        <template #title>
          <span class="meta-title">{{ item.meta.title }}</span>
        </template>
        <sysytemSubMenu :menus="item.children"></sysytemSubMenu>
      </el-sub-menu>
    </template>
    <template v-else>
      <el-menu-item :index="item.path" @click="clickMenuItem(item)">
        <span class="meta-title" :title="item.meta.title">
          {{ item.meta.title }}</span
        >
      </el-menu-item>
    </template>
  </template>
</template>

<script>
import {
  defineComponent,
  reactive,
  getCurrentInstance,
  toRefs,
  onMounted,
  ref,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getToken } from "@/utils/auth";

export default defineComponent({
  name: "sysytemSubMenu",
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const formState = reactive({});
    const clickMenuItem = (item) => {
      if (item.isFrame.value == 0) {
        const token = getToken();
        let url;
        if (item.path.includes("?")) {
          url = `${item.path}&token=${token}`;
        } else {
          url = `${item.path}?token=${token}`;
        }

        window.open(url);
      } else {
        router.push(item.path);
        const routeTabs = store.getters.routeTabs;
        const index = routeTabs.findIndex((route) => item.path === route.path);
        if (index < 0) {
          routeTabs.push(item);
        }

        store.commit("permission/SET_ROUTE_TABS", routeTabs);
      }
    };
    return {
      ...toRefs(formState),
      clickMenuItem,
    };
  },
});
</script>
<style lang="less" scoped>
.meta-title {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-emphasis: ellipsis;
  color: #fff;
}
</style>
